<template>
	<b-form @submit.prevent>
	  <b-row>
		<!-- Status Field -->
		<b-col v-if="!hideStatus" cols="12" sm="6" lg="6" xl="4">
		  <b-form-group label-cols-lg="4" label="Status" label-for="status">
			<b-form-select
			  name="status"
			  v-model="filters.status"
			  :class="{ highlight: filters.status !== null }"
			  @change="highlight"
			  :disabled="disabled"
			  :options="caseStatuses"
			  text-field="name"
			  value-field="value"
			>
			  <template #first>
				<option :value="null">(All)</option>
			  </template>
			</b-form-select>
		  </b-form-group>
		</b-col>
		<b-col v-if="!hideOpen" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Status" label-for="open" label-cols-lg="4">
					<b-form-select
						name="open"
						v-model="open"
						:disabled="false"
						class="open"
						
					>
					
				      <option value="Open">Open</option>
			        
					</b-form-select>
				</b-form-group>
            </b-col>
			<b-col v-if="!hideClose" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Status" label-for="close" label-cols-lg="4">
					<b-form-select
						name="close"
						v-model="close"
						:disabled="false"
						class="open"
						
					>
					    <option value="Close">Closed</option>
					</b-form-select>
				</b-form-group>
            </b-col>
		<!-- Denial Type Field -->
		<!-- <b-col cols="12" sm="6" lg="6" xl="4">
		  <b-form-group label-cols-lg="4" label="Denial Type" label-for="denial_type_id">
			<b-form-select
			  name="denial_type_id"
			  v-model="filters.denial_type_id"
			  :class="{ highlight:filters.denial_type_id !== null }"
			  @change="highlight"
			  :disabled="disabled"
			  :options="denialTypes"
			  value-field="id"
			  text-field="name"
			>
			  <template #first>
				<option :value="null">(All)</option>
			  </template>
			</b-form-select>
		  </b-form-group>
		</b-col> -->
		<!-- <b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label="Closure Reason" label-for="denial_reason_id" label-cols-lg="4">
					<b-form-select
						name="denial_reason_id"
						v-model="filters.denial_reason_id"
						:disabled="disabled"
						:options="denialReasons"
						value-field="id"
						text-field="name"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col> -->
			<!-- <b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Facility" label-for="facility_id">
					<b-form-select
						name="facility_id"
						v-model="filters.facility_id"
						:disabled="disabled"
						:options="facilities"
						value-field="id"
						text-field="name"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col> -->
		<!-- Current Level Field -->
		<b-col cols="12" sm="6" lg="6" xl="4">
		  <b-form-group label-cols-lg="4" label="Current Level" label-for="insurance_appeal_id">
			<b-form-select
			  name="insurance_appeal_id"
			  v-model="filters.insurance_appeal_id"
			  :class="{ highlight:filters.insurance_appeal_id !== null}"
			  @change="highlight"
			  :disabled="disabled"
			  :options="appealLevels"
			  text-field="name"
			  value-field="id"
			  
			>
			  <template #first>
				<option :value="null">(All)</option>
			  </template>
			</b-form-select>
		  </b-form-group>
		</b-col>
		<!-- <b-col v-if="!hideOutcome" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Outcome" label-for="case_outcome_id">
					<b-form-select
						name="case_outcome_id"
						v-model="filters.case_outcome_id"
						:disabled="disabled"
						:options="caseOutcomes"
						value-field="id"
						text-field="name"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col> -->
		<!-- Facility Field -->
		<b-col cols="12" sm="6" lg="6" xl="4">
			<b-form-group label-cols-lg="4" label="Facility" label-for="facility_name">
				<search-input
				name="facility_name"
				v-model="filters.facility_name"
				:key="filters.facility_name"  
				:class="{ highlight: filters.facility_name && filters.facility_name.trim() !== '' }"
				@input="handleInput"
				:disabled="disabled"
				/>
			</b-form-group>
		</b-col>

		<!-- Insurance Provider Field -->
		<b-col cols="12" sm="6" lg="6" xl="4">
		  <b-form-group label-cols-lg="4" label="Insurance Provider" label-for="insurance_provider_id">
			<b-form-select
			  name="insurance_provider_id"
			  v-model="filters.insurance_provider_id"
			  :class="{ highlight: filters.insurance_provider_id !== null }"
			  @change="highlight"
			  :disabled="disabled"
			  :options="insuranceProviders"
			  value-field="id"
			  text-field="name"
			>
			  <template #first>
				<option :value="null">(All)</option>
			  </template>
			</b-form-select>
		  </b-form-group>
		</b-col>
		<!-- Insurance Provider Type Field -->
		<b-col cols="12" sm="6" lg="6" xl="4">
		  <b-form-group label-cols-lg="4" label="Ins. Prov. Type" label-for="insurance_type_id">
			<b-form-select
			  name="insurance_provider_type_id"
			  v-model="filters.insurance_provider_type_id"
			  :class="{ highlight: filters.insurance_provider_type_id !== null }"
			  @change="highlight"
			  :disabled="disabled"
			  :options="insurance_provider_types_options"
			  value-field="id"
			  text-field="insurance_provider_type"
			>
			  <template #first>
				<option :value="null">(All)</option>
			  </template>
			</b-form-select>
		  </b-form-group>
		</b-col>
		<!-- <b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Insurance Plan" label-for="insurance_plan">
					<b-form-input name="insurance_plan" v-model="filters.insurance_plan" :disabled="disabled" lazy />
				</b-form-group>
			</b-col> -->

		<!-- Assigned To Field -->
		<!-- <b-col cols="12" sm="6" lg="6" xl="4"> -->
			<!-- {{ activeUsers }} -->
		  <!-- <b-form-group label-cols-lg="4" label="Assigned To" label-for="assigned_to">
			<b-form-select
			  name="assigned_to"
			  v-model="filters.assigned_to"
			  :class="{ highlight: isUsed.assigned_to }"
			  @change="highlight('assigned_to')"
			  :options="activeUsers"
			  :disabled="disabled"
			  value-field="id"
			  text-field="full_name"
			>
			  <template #first>
				<option :value="null">(All)</option>
				<option :value="false">(Unassigned)</option>
			  </template>
			</b-form-select>
		  </b-form-group> -->
		  <!-- <b-form-group label-cols-lg="4" label="Assigned To" label-for="assigned_to">
				<b-dropdown id="dropdown-1" class="mb-2" variant="light" v-model="filters.assigned_to">
				<b-dropdown-item :value="null">All</b-dropdown-item>
				<b-dropdown-item :value="false">Unassigned</b-dropdown-item>
				<b-dropdown-item
					v-for="user in activeUsers"
					:key="user.id"
					:value="user.id"
					:class="{ 'text-muted': !user.active }"
				>
					{{ user.full_name }}
					<b-badge pill v-if="!user.active" variant="success" class="ml-2">Inactive</b-badge>
				</b-dropdown-item>
				</b-dropdown>
			</b-form-group> 
		</b-col> -->
		<b-col cols="12" sm="6" lg="6" xl="4">
		<b-form-group label-cols-lg="4" label="Assigned To" label-for="assigned_to">
			<b-form-select
			v-model="filters.assigned_to"
			class="w-100"
			:class="{ highlight:filters.assigned_to !== null }"
			@change="highlight"
			:disabled="disabled"
			>
			<option :value="null">(All)</option>
			<option :value="false">(Unassigned)</option>
			<option
				v-for="user in activeUsers"
				:key="user.id"
				:value="user.id"
			>
				{{ user.full_name }} <span v-if="!user.active">(Inactive)</span>
			</option>
			</b-form-select>
		</b-form-group>
		</b-col>

		<!-- Begin DOS Field -->
		<b-col cols="12" sm="6" lg="6" xl="4">
		  <b-form-group label-cols-lg="4" label="Begin DOS" label-for="admit_date">
			<b-form-input
			  name="admit_date"
			  type="date"
			  v-model="filters.admit_date"
			  :class="{ highlight: filters.admit_date !== null }"
			  @input="highlight('admit_date')"
			  :disabled="disabled"
			/>
		  </b-form-group>
		</b-col>
		<!-- MRT Number Field -->
		<b-col cols="12" sm="6" lg="6" xl="4">
			<b-form-group label-cols-lg="4" label="MRT Number" label-for="mrt_number">
				<search-input
				name="mrt_number"
				v-model="filters.mrt_number"
				:key="filters.mrt_number"  
				:class="{ highlight: filters.mrt_number && filters.mrt_number.trim() !== '' }"
				@input="(value) => filters.mrt_number = value !== '' ? value : null"
				:disabled="disabled"
				/>
			</b-form-group>
		</b-col>

		<!-- Case ID Field -->
		<b-col cols="12" sm="6" lg="6" xl="4">
			<b-form-group label-cols-lg="4" label="Case ID" label-for="id">
				<search-input
				name="id"
				v-model="filters.id"
				:key="filters.id" 
				:class="{ highlight: filters.id && filters.id.trim() !== '' }"
				@input="(value) => filters.id = value !== '' ? value : null"
				:disabled="disabled"
				/>
			</b-form-group>
		</b-col>


			<!-- <b-col cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Discharge Date" label-for="discharge_date">
					<b-form-input
						name="discharge_date"
						type="date"
						v-model="filters.discharge_date"
						:disabled="disabled"
					/>
				</b-form-group>
			</b-col> -->
		<!-- <b-col v-if="!hideEmpty" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Case Empty" label-for="case_empty">
					<b-form-select
						name="case_empty"
						v-model="filters.empty"
						:disabled="disabled"
						:options="emptyOptions"
						value-field="value"
						text-field="name"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col> -->
			<!-- <b-col v-if="!hideUTC" cols="12" sm="6" lg="6" xl="4">
				<b-form-group label-cols-lg="4" label="Unable To Complete" label-for="unable_to_complete">
					<b-form-select
						name="unable_to_complete"
						v-model="filters.unable_to_complete"
						:disabled="disabled"
						:options="utcOptions"
						value-field="value"
						text-field="text"
					>
						<template #first>
							<option :value="null">(All)</option>
						</template>
					</b-form-select>
				</b-form-group>
			</b-col> -->
	  </b-row>
	</b-form>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import { debounce } from "lodash";
  import axios from "axios";
  
  export default {
	name: "CaseFilters",
	props: {
	  value: {
		type: Object,
		default: () => ({
		  status: null,
		  case_type_id: null,
		  client_employee_id: null,
		  denial_type_id: null,
		  denial_reason_id: null,
		  facility_name: null,
		  appeal_level_id: null,
		  case_outcome_id: null,
		  insurance_provider_id: null,
		  insurance_type_id: null,
		  insurance_plan: null,
		  admit_date: null,
		  discharge_date: null,
		  empty: null,
		  assigned_to: null,
		  unable_to_complete: null,
		  mrt_number: null,
		  id: null,
		  insurance_provider_type_id: null,
		  insurance_appeal_id: null,
		}),
	  },
	  disabled: {
		type: Boolean,
		default: false,
	  },
	  hideEmpty: {
		type: Boolean,
		default: false,
	  },
	  hideStatus: {
		type: Boolean,
		default: false,
	  },
	  hideOutcome: {
		type: Boolean,
		default: false,
	  },
	  hideUTC: {
		type: Boolean,
		default: false,
	  },
	  renderCaseStatus: {
		type: Boolean,
		default: false,
	  },
	  hideOpen: {
			type: Boolean,
			default: true,
		},
	  hideClose: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
	  filters: {
		get() {
			
		  return this.value;
		},
		set(val) {
		  this.$emit("input", val);
		},
	  },
	  ...mapGetters({
		activeUsers: "users/active",
		appealLevels: "appealLevels/all",
		caseStatuses: "cases/statuses",
		caseTypes: "caseTypes/all",
		denialReasons: "denialReasons/all",
		denialTypes: "denialTypes/all",
		insuranceProviderAppealLevels: "insuranceProviderAppealLevels/all",
		insuranceProviders: "insuranceProviders/active",
	  }),
	  
	},
	data() {
	  return {
		loading: true,
		open:'Open',
		close:'Close',
		yesNoOptions: [
		  {
			value: true,
			name: "Yes",
		  },
		  {
			value: false,
			name: "No",
		  },
		],
		utcOptions: [
		  { text: "Yes", value: true },
		  { text: "No", value: false },
		],
		responseData: null,
		insurance_provider_types_options: null,
		isUsed: {
		  status: false,
		  case_type_id: false,
		  client_employee_id: false,
		  denial_type_id: false,
		  denial_reason_id: false,
		  facility_name: false,
		  appeal_level_id: false,
		  case_outcome_id: false,
		  insurance_provider_id: false,
		  insurance_type_id: false,
		  insurance_plan: false,
		  admit_date: false,
		  discharge_date: false,
		  empty: false,
		  assigned_to: false,
		  unable_to_complete: false,
		  mrt_number: false,
		  id: false,
		  insurance_provider_type_id: false,
		  insurance_appeal_id:false,
		},
	  };
	},
	methods: {
	highlight(field) {
      this.$set(this.isUsed, field, this.filters[field] !== null && this.filters[field] !== "");
    },
	},
	async created() {
	  try {
		const response = await axios.get("/client/api/insuraceProviderTypes");
		this.responseData = response.data;
		
	  } catch (error) {
		console.error("Error:", error);
	  } finally {
		this.loading = false;
	  }
  
	  try {
		const response = await axios.get("/client/api/getCaseDetails");
		this.insurance_provider_types_options = response.data;
		
	  } catch (error) {
		console.error("Error:", error);
	  } finally {
		this.loading = false;
	  }
	},
  };
  
  </script>
	<style>
	.highlight {
	border: 2px solid #007bff; /* Example: blue border */
	box-shadow: 0 0 5px rgba(0, 123, 255, 0.5); /* Optional: blue shadow */
	}
	.open {
	border: 2px solid #007bff; /* Example: blue border */
	box-shadow: 0 0 5px rgba(0, 123, 255, 0.5); /* Optional: blue shadow */
	color:black;
	}

	</style>  